import React from 'react';
import SectionContainer from '../../../common/SectionContainer';
import FieldRow from '../../../common/FieldRow';

const CreditoIPESection = ({ data, computed }) => {
  const ipe = data.creditoIPE;
  const comp = computed.creditoIPE || {};

  return (
    <SectionContainer title="Crédito IPE" subtitle="Impuestos Pagados en el Exterior">
      <div className="f22-subsection">
        <h4 className="f22-subsection-title">Antecedentes de la renta de fuente extranjera</h4>
        <FieldRow label="Régimen tributario" value="Artículo 14 letra D) N°3 LIR" type="text" computed />
        <FieldRow label="Dividendo fuente extranjera percibido (USD)" value={ipe.dividendoExtranjeroUSD} type="number" disabled />
        <FieldRow label="Tipo de cambio Dólar EE.UU" value={ipe.tipoCambioDolar} type="number" decimals={2} disabled />
        <FieldRow label="Tasa retención soportado en el extranjero" value={ipe.tasaRetencion * 100} type="number"
          suffix="%" computed />
        <FieldRow label="Tasa impuesto corporativo soportado en el extranjero" value={ipe.tasaCorporativo * 100} type="number"
          suffix="%" computed />
      </div>

      <div className="f22-subsection">
        <h4 className="f22-subsection-title">Determinación crédito por IPE</h4>

        <h5 className="f22-label-group">(a) Renta Neta</h5>
        <FieldRow label="Dividendo extranjero percibido en pesos" value={comp.dividendoEnPesos} computed />
        <FieldRow label="Pérdidas relacionadas al dividendo" sign="(-)" value={ipe.perdidasRelacionadas} disabled />
        <FieldRow label="Gastos relacionados al dividendo" sign="(-)" value={ipe.gastosRelacionados} disabled />
        <FieldRow label="Renta Neta" sign="(=)" value={comp.rentaNeta} computed className="f22-field-highlight" />

        <h5 className="f22-label-group">(b) Tope Individual (cantidad menor)</h5>
        <FieldRow label="Tope Individual" sign="(=)" value={comp.topeIndividual} computed />

        <h5 className="f22-label-group">(c) Tope Global ((a) + (b)) x 35%</h5>
        <FieldRow label="Tope Global" sign="(=)" value={comp.topeGlobal} computed />

        <h5 className="f22-label-group">(d) CTD (menor entre (b) y (c))</h5>
        <FieldRow label="CTD" sign="(=)" value={comp.ctd} computed className="f22-field-highlight" />

        <h5 className="f22-label-group">(e) Renta Imponible ((a) + (d))</h5>
        <FieldRow label="Renta Imponible" sign="(=)" value={comp.rentaImponible} computed className="f22-field-highlight" />
      </div>

      <div className="f22-subsection">
        <h4 className="f22-subsection-title">Determinación de la imputación del CTD</h4>
        <FieldRow label="Crédito por IPE imputable al IDPC" value={comp.creditoIPEContraIDPC} computed />
        <FieldRow label="Crédito por IPE imputable a IF (registrar en SAC)" value={comp.creditoIPEContraIF} computed />
      </div>
    </SectionContainer>
  );
};

export default CreditoIPESection;
